import { useContext } from "react";

import { PropertiesPaneContext } from "./context";

export const usePropertiesPane = () => useContext(PropertiesPaneContext);
